<template>
  <PaOverlayModal
   :appendClass="['pa-overlay-modal-default-transition', 'pa-logined-view-tokusho-modal']"
   :additionalZIndex="2"
   :isOpen="isOpenModal"
   :position="{top: .15}"
   :isFreez="isFreezModal"
   :couldOverlaySwipeClose="false"
   contentTransitionName="trans-content"

   @closeOverlayModal="handleCloseOverlay"
   @afterEnterContent="handleEnterContent"
   @afteredAfterEnterContent="handleAfterEnterContent"
  >
   <div class="pa-wide-modal-box-wrapper pa-logined-view-tokusho-modal-view">
    <div class="pa-wide-modal-box" ref="wideModalBox">
      <div class="pa-content" ref="paContent">
        <transition name="pa-simple-fade">
          <div class="pa-tokusho-message" v-if="this.isEnterdModal && this.isInitializedContentHeight">
            <p class="title">特定商取引法に基づく表記</p>
            <PATokusho />
          </div>
        </transition>
      </div>
      
      <div class="pa-cancel-wrapper" ref="paCancel">
        <div class="pa-cancel">
          <button
          class="button pa-cancel-button"
          :class="cancelButtonClass"
          :disabled="isDisabledCancelButton"
          @click.prevent="handleCloseModal"
          >閉じる</button>
        </div>
      </div>
    </div>
   </div>
  </PaOverlayModal>
</template>

<script>
import PaOverlayModal from '@/components/Parts/PAOverlayModal/PAOverlayModal.vue'

import PATokusho from '@/components/Parts/PATokusho/PATokusho.vue'

export default {
  components : {
    PaOverlayModal,

    PATokusho
  },

  data(){
    return {
      isOpenModal   : false,
      isFreezModal  : false,

      cancelButtonClass         : [],
      isDisabledCancelButton    : false,

      isEnterdModal               : false,
      isInitializedContentHeight  : false
    };
  },

  computed : {
    urlQuery(){
      return this.$route.query;
    },

    isShowTokusho(){
      return process.env.VUE_APP_IS_SHOW_TOKUSHO;
    }
  },

  watch : {
    urlQuery : {
      handler(data){
        if(typeof data !== 'object') return;

        this.isEnterdModal = false;
        this.isInitializedContentHeight = false;

        this.$nextTick(() => {
          if(
            (this.isShowTokusho === 'true') &&
            (typeof data.open_tokusho_modal !== 'undefined')
          ){
            this.isOpenModal = true;
          }else{
            this.isOpenModal = false;
          }
        });
      },
      immediate: true,
      deep: true
    }
  },

  methods : {
    setModalContentHeight(){
      const maxTime   = 50;
      let timeCounter = 0;

      const intervalTimer = setInterval(() => {
        const actualBoxHeight = this.$refs.wideModalBox.offsetHeight;

        const cancelHeight  = this.$refs.paCancel.offsetHeight;

        timeCounter++;

        if(timeCounter > maxTime){
          this.isInitializedContentHeight = true;
          clearInterval(intervalTimer);
        }

        if(actualBoxHeight === 0) return;

        const contentHeight = actualBoxHeight - cancelHeight;

        this.$refs.paContent.style.height = contentHeight+'px';

        this.isInitializedContentHeight = true;
        clearInterval(intervalTimer);
      }, 100);
    },

    handleCloseModal(){
      this.isOpenModal = false;
    },

    handleCloseOverlay(){
      this.isOpenModal = false;

      const newUrlQuery = Object.assign({}, this.$route.query);

      if(newUrlQuery['y'] === 0){
        delete newUrlQuery.y;
      }

      delete newUrlQuery.open_tokusho_modal;

      this.$router.push({
        name    : this.$route.name,
        params  : this.$route.params,
        query   : newUrlQuery
      });
    },

    handleEnterContent(){
      this.setModalContentHeight();
    },

    handleAfterEnterContent(){
      this.$nextTick(() => {
        this.isEnterdModal = true;
      });
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

.pa-logined-view-tokusho-modal-view{
  .pa-wide-modal-box{
    overflow: hidden;

    .pa-content{
      padding-top:1rem;
      overflow-y: scroll;

      .pa-tokusho-message{
        color: #363636;
        text-align: left;
        font-size:1rem;
        padding:.5rem;

        p.title{
          margin: 0 auto .4rem;
          text-align: center;
          font-size: 1.2rem;
          line-height: 1;
          padding: 0 0 .2rem;
          border-bottom: .2rem solid #BFA07C;
          width: 70%;
          user-select: none;
        }

        p.update{
          text-align: right;
        }

        h4{
          margin-top:1.5rem;
        }
      }
    }

    .pa-cancel-wrapper{
      box-sizing:border-box;
      padding-top:.5rem;
      padding-bottom:1rem;

      .pa-cancel{
        box-sizing:border-box;

        margin-top:0;
        border-top:1px solid #C6AA89;
        text-align: center;

        button{
          margin-top:.4rem;
          font-size:1.2rem;
          font-weight: normal;
        }
      }
    }
  }
}
</style>